<template>
  <div id="media" class="main">
    <div class="color-change">
      <div style="height: 40px;"></div>
      <div class="content-wrap">
        <div class="title ft-25">{{ item.TITLE }}</div>
        <div class="date ft-16">{{ item.SHOWTIME | dateFilter }}</div>
        <div class="detail ft-14" v-html="item.CONTENT"></div>

        <div class="btn-wrap">
          <Morebtn :dark="true"
            :text="$t('btn3')"
            @btn-click="gotoFatherPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Morebtn from '@/components/Morebtn.vue'
import { getMediaUrl } from '@/util/url.js'
import axios from 'axios'

export default {
  components: {
    Morebtn
  },

  mounted () {
    document.title = `${this.$t('nav.medias')}-${this.$t('title')}`
    this.fechData()

    this.$nextTick(() => {
      if (window.scrollBar) window.scrollBar.scrollTop = 0

      // setTimeout(() => {
      //   this.loader.hide()
      // }, 300)
    })
  },

  data () {
    return {
      item: {
        TITLE: '',
        SHOWTIME: '',
        CONTENT: ''
      }
    }
  },

  methods: {
    fechData () {
      const id = this.$route.params.id
      const url = getMediaUrl(id)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data) {
          this.item = res.data
        }
      })
    },

    gotoFatherPage () {
      const fid = this.$route.params.fid
      this.$router.push(`/medias/${fid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  background-color: #cae6f9;
}
.color-change {
  background: linear-gradient(#cae6f9, #cae6f9, #fff);
}

.content-wrap {
  min-width: 100vh;
  margin: 100px;
  padding: 100px;
  background-color: #fff;

  .title {
    text-align: center;
    line-height: 100px;
  }

  .date {
    text-align: center;
    line-height: 32px;
  }

  .detail {
    padding: 100px;
  }
}

.btn-wrap {
  border-top: 1px solid #ddd;
  padding-top: 30px;
  display: flex;
  justify-content: flex-end;
}
@media(max-width: 768px){
  .content-wrap{
    margin-left: 0;
    margin-right: 0;
    min-width: auto;
    padding: 20px;
    .detail{
      padding: 0;
    }
  }
}
</style>
